import React from 'react';
import { Link } from 'react-router-dom';
import styles from '../thyagolashman/thyagolashman.module.scss';
import perfil from '../thyagolashman/src/perfil.png';
import WhatsappIcon from '../../icons/whatsappIcon.tsx';

const cardImages = [
    {
        id: 1,
        image: require("./src/cards/1.png"),
        link: "/thyagolashman/agendamento",
        linkInterno: true,
    },
    {
        id: 2,
        image: require("./src/cards/2.png"),
        link: "/thyagolashman/procedimentos",
        linkInterno: true,
    },
    {
        id: 3,
        image: require("./src/cards/3.png"),
        link: "https://maps.app.goo.gl/ygFhmUeFCmGmg7WB7",
        linkInterno: false,
    },
];

const Thyagolashman: React.FC = () => {
    const whatsappLink = `https://wa.me/553298527555`;

    return (
        <div className={styles.thyagolashman}>
            <div className={styles.container}>
                <img src={perfil} alt="Perfil" className={styles.perfil} />
                <div className={styles.cards}>
                    {cardImages.map((card, index) =>
                        card.linkInterno ? (
                            <Link to={card.link} key={index} className={styles.card}>
                                <img src={card.image} alt={`Card ${card.id}`} />
                            </Link>
                        ) : (
                            <a href={card.link} target="_blank" rel="noopener noreferrer" key={index} className={styles.card}>
                                <img src={card.image} alt={`Card ${card.id}`} />
                            </a>
                        )
                    )}
                </div>
            </div>
        </div>
    );
};

export default Thyagolashman;
